import * as React from 'react';
import * as Classes from '../common/classes';
import { IProps } from '../common/props';
import classNames from 'classnames';
import { Icon } from '../icon/Icon';
import { mcWarning } from '@mc/react-ui-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IAppErrorProps extends IProps {
  message: string;
  noCenter?: boolean;
  /**
   * Pokud není uvedeno, použije se výchozí ikona chyby (mcWarning).
   */
  icon?: IconProp;
}

export type AppErrorProps = IAppErrorProps;

export const AppError: React.FC<AppErrorProps> = ({
  className,
  message,
  icon,
  noCenter,
  style,
  children,
}) => {
  return (
    <div
      className={classNames(className, Classes.APP_ERROR, {
        [Classes.APP_ERROR_NO_CENTER]: noCenter,
      })}
      style={style}
    >
      <div className={Classes.APP_ERROR_ICON}>
        <Icon size={'4x'} icon={icon || mcWarning} />
      </div>
      <div className={Classes.APP_ERROR_MESSAGE}>{message}</div>
      <div className={Classes.APP_ERROR_CONTENT}>{children}</div>
    </div>
  );
};
